var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.authFlag)?[_c('navbar'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('sidebar'),_vm._v(" "),_c('div',{staticClass:"col-sm-10 main"},[_c('router-view')],1)],1)]:[_c('login-form')],_vm._v(" "),_c('vue-snotify')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5687592","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = QoGY
// module chunks = 1